<script>
    import { ItemType, itemsInfo, ItemId } from 'json/itemsInfo.js'
    import { buildSources, requestMajesticClothes, glyphClass } from './itemPhoto.js'

    export let item;
    export let defaultIcon;
    export let defaultName;
    export let defaultStyle;

    let iconInfo = itemsInfo [item.ItemId];

    let sources = [];
    let index = 0;
    let lastKey = "";

    $: if (item) {
        iconInfo = itemsInfo [item.ItemId];
        const key = item.ItemId + "|" + (item.Data || "");
        if (key !== lastKey) {
            lastKey = key;
            sources = buildSources(item, iconInfo);
            index = 0;
            // одежда: адрес у маджестика приходит асинхронно (хеш модели считает клиент)
            requestMajesticClothes(item, (url) => {
                if (key !== lastKey || sources.indexOf(url) >= 0) return;
                sources = [url, ...sources];
                index = 0;
            });
        }
    }

    // промах: следующий источник, а когда они кончились — глиф иконо-шрифта
    const nextSource = () => {
        index = (index < sources.length - 1) ? index + 1 : sources.length;
    };

    $: currentSrc = sources[index] || "";
    $: showGlyph = !currentSrc;

    const Bool = (text) => {
        return String(text).toLowerCase() === "true";
    }

    const GetClothesClass = (_iconInfo, _item) => {
        if (_iconInfo.functionType === ItemType.Clothes && _item.ItemId != -5 && _item.ItemId != -9 && _item.ItemId != -1 && _item.Data.split("_").length >= 2) {
            return Bool(item.Data.split("_")[2]) ? "clothesM" : "clothesF"
        }
        return "";
    }

</script>
    {#if item && item.ItemId != 0}
        <div class="itemblock" on:mouseenter on:mouseleave>
            <h1>{itemsInfo [item.ItemId].Name} {#if defaultIcon === undefined && iconInfo.functionType === 1 && item.ItemId != -5 && item.ItemId != -9 && item.ItemId != -1 && item.Data.split("_").length >= 2}{Bool(item.Data.split("_")[2]) ? "М" : "Ж"}{/if}</h1>
            {#if showGlyph}<span class="{glyphClass(iconInfo)}" style="font-size:3vh;line-height:1;display:flex;align-items:center;justify-content:center;color:#c9c9d4" />{:else}<img src="{currentSrc}" alt="" on:error={nextSource}>{/if}
            <span>{item.Count}<b>шт.</b></span>
        </div>
    {/if}
